import { createSlice,createAsyncThunk } from "@reduxjs/toolkit";
import { STATUS_ENUM } from "../../utils/helper.ts"; // Adjust based on the actual location
import { toast } from "react-toastify";
import { getHomeContent } from "../services/HomePage/home.service";

export const getHomePageContent = createAsyncThunk(
    "homePage/getHomePageContentAsync",
    async(payload,{rejectWithValue,fulfillWithValue})=>{
        try{
            const response=await getHomeContent();
            return fulfillWithValue(response);
        }catch(error){
            return rejectWithValue(error);
        }
    }
)

const initialState = {
    firstSectionContent:[],
    getContentStatus:STATUS_ENUM.IDLE,
}

const homePageSlice = createSlice({
    name: "homeContent",
    initialState,
    reducers: {
        setState: (state, payload) => {
            // Reducer logic here
        },
        resetState: (state) => {
            // Reducer logic here
        },
    },
    extraReducers: (builder) => { 
        builder
            .addCase(getHomePageContent.pending, (state, action) => {
                state.getContentStatus = STATUS_ENUM.LOADING;
            })
            .addCase(getHomePageContent.fulfilled, (state, action) => {
                state.firstSectionContent=action.payload;
                state.getContentStatus = STATUS_ENUM.SUCCESS;
            })
            .addCase(getHomePageContent.rejected, (state, action) => {
                state.getContentStatus = STATUS_ENUM.FAILED;
            });
    },
});

export const {setState,resetState}=homePageSlice.actions;
export default homePageSlice.reducer;